import { AppImage } from '@/components/Images';
import { cn } from '@/utils';
import { ISimulationPlanningCardContentSection } from '@/types';
import { roleplayCardIntroStyles } from '../../../Cards/RoleplayCard/RoleplayCard.styles';
import React from 'react';

interface Props {
  imageType?: 'default' | 'persona';
  section: ISimulationPlanningCardContentSection;
}

/**
 * ContentImage
 *
 * Renders the image for a planning card content section. If no image is provided,
 * this component renders nothing. For persona images, applies special styling to
 * fit roleplay design requirements.
 */
export const ContentImage: React.FC<Props> = ({ imageType = 'default', section }) => {
  const styles = roleplayCardIntroStyles;
  const { src, alt, width, height } = section?.image ?? {};

  if (!section?.image || !src) {
    return null;
  }

  return (
    <AppImage
      alt={alt ?? ''}
      className={imageType === 'persona' ? cn(styles.avatarImage, 'size-36') : undefined}
      data-key="section.image"
      height={height ?? 0}
      src={src}
      width={width ?? 0}
    />
  );
};
